/**
 * Helper functions for creating modal templates
 */

/**
 * Creates the V2 styled template for the cancel order modal
 * @param {Function} h - Vue's createElement function ($createElement)
 * @returns {VNode} The VNode for the cancel order modal template
 */
export function createCancelOrderModalV2Template(h) {
  return h("div", { class: ["cancel-order-modal-v2"] }, [
    // Icon
    h("div", { class: ["cancel-order-modal-v2-icon"] }, [
      h("svg", {
        attrs: {
          width: "64",
          height: "64",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      }, [
        h("circle", { attrs: { cx: "12", cy: "12", r: "10" } }),
        h("line", { attrs: { x1: "15", y1: "9", x2: "9", y2: "15" } }),
        h("line", { attrs: { x1: "9", y1: "9", x2: "15", y2: "15" } })
      ])
    ]),
    // Title
    h("h2", { class: ["cancel-order-modal-v2-title"] }, "Cancel this order?"),
    // Message
    h("p", { class: ["cancel-order-modal-v2-message"] }, "Are you sure you want to cancel this order?")
  ]);
}
